import _ from 'lodash'

export const fixedDecimalPlace = (number: number) => {
  return number.toFixed(2)
}

export const getLoanToValue = (propertyValue: number, loanRequired: number) => {
  return parseFloat(fixedDecimalPlace((loanRequired / propertyValue) * 100))
}

export const getLoanToValueSharedOwnership = (
  shareValue: number,
  loanRequired: number
) => {
  if (!loanRequired || !shareValue) {
    return 0
  }
  if (
    parseFloat(fixedDecimalPlace((loanRequired / shareValue) * 100)) > 100 ||
    parseFloat(fixedDecimalPlace((loanRequired / shareValue) * 100)) <= 0
  ) {
    return 0
  }
  return parseFloat(fixedDecimalPlace((loanRequired / shareValue) * 100))
}

export const getPercentagePurchased = (
  shareValue: number,
  propertyValue: number
) => {
  return _.ceil((shareValue / propertyValue) * 100)
}

export const percentagePurchaseReverseCalc = (
  shareValue: number,
  propertyValue: number,
  percent: number
) => {
  if (propertyValue > 0) {
    return {
      shareValue: parseFloat(
        fixedDecimalPlace(propertyValue * (+percent * 0.01))
      ),
      propertyValue,
    }
  } else if (shareValue > 0) {
    return {
      shareValue,
      propertyValue: parseFloat(
        fixedDecimalPlace(shareValue * ((+percent + 100) * 0.01))
      ),
    }
  }
}

export const formatMonetaryValue = (value: number) => value.toFixed(2)
